<template>
  <div style="width: 100%">
    <v-row
      ><v-col
        ><p class="title">{{ title }}</p></v-col
      >
      <v-col>
        <p class="legend-previous-date">
          {{ getLabelFromPath(['previousTLEDate'], 'AbstractEvent') }} :
          {{
            getDisplayValueFromPath(
              previousDate,
              ['previousTLEDate'],
              'AbstractEvent'
            )
          }}&emsp;
        </p></v-col
      >
      <v-col>
        <p class="legend-last-position-date">
          {{ getLabelFromPath(['lastFollowingTleDate'], 'AbstractEvent') }} :
          {{
            getDisplayValueFromPath(
              lastPositionDate,
              ['lastFollowingTleDate'],
              'AbstractEvent'
            )
          }}
        </p></v-col
      ><v-col>
        <v-switch v-model="isAllLife" :label="'All life'"></v-switch>
      </v-col>
    </v-row>
    <FullscreenGraphComponent
      :traces="getTraceOrbitalsElements"
      :layout="getLayoutOrbitalsElements"
      style="width: 100%; height: 400px"
      :maneuversDates="reactiveManeuverDate"
      :title="title"
    />
  </div>
</template>
<script>
import errorMixin from '@/mixins/logHandler'
import FullscreenGraphComponent from '../Asterx/FullscreenGraphComponent.vue'
import defense from '../../mixins/defense'

export default {
  name: 'ScreeningCatalogueAnalysisPlotsOrbitParameters',

  mixins: [errorMixin, defense],
  components: { FullscreenGraphComponent },
  data() {
    return {
      orbitalData: null,
      title: 'Mean Keplerian Elements',
      isAllLife: false,
      reactiveManeuverDate: [],
      contextOrbitalElement: 'OrbitalElements'
    }
  },
  props: {
    tles: {
      type: Array
    },
    maneuverDates: {
      type: Array
    },
    idMission: {
      type: String
    },
    idSatellite: {
      type: String
    }
  },
  watch: {
    isAllLife(newValue) {
      this.updateDataOrbitalsElements(newValue)
    },
    idMission() {
      this.updateDataOrbitalsElements(this.isAllLife)
    },
    idSatellite() {
      this.updateDataOrbitalsElements(this.isAllLife)
    },
    maneuverDates() {
      this.updateDataOrbitalsElements(this.isAllLife)
    },
    datasOrbitals(newValue) {
      this.updateTraceOrbitalsElements(newValue)
    }
  },
  async mounted() {
    this.updateDataOrbitalsElements(this.isAllLife)
  },
  computed: {
    previousDate() {
      if (this.maneuverDates[0].dates[0][0] != null) {
        return this.maneuverDates[0].dates[0][0]
      } else {
        return ''
      }
    },
    lastPositionDate() {
      if (this.maneuverDates[0].dates[0][1] != null) {
        return this.maneuverDates[0].dates[0][1]
      } else {
        return ''
      }
    },
    getLayoutOrbitalsElements() {
      return {
        plot_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        paper_bgcolor: this.$vuetify.theme.dark ? '#1E1E1E' : 'white',
        font: { color: this.$vuetify.theme.dark ? 'white' : '#121212' },
        xaxis: {
          title: { text: 'Time (Days)', type: 'date' },
          domain: [0.21, 0.925]
        },
        yaxis: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['semiMajorAxis'],
              this.contextOrbitalElement
            )
          },
          color: 'blue',
          side: 'right',
          position: 0.925
        },
        yaxis2: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['inclination'],
              this.contextOrbitalElement
            )
          },
          color: 'green',
          side: 'left',
          position: 0.21,
          overlaying: 'y',
          anchor: 'free',
          overlaying: 'y'
        },
        yaxis3: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['eccentricity'],
              this.contextOrbitalElement
            )
          },
          color: 'red',
          side: 'right',
          position: 1,
          anchor: 'free',
          overlaying: 'y'
        },
        yaxis4: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['raan'],
              this.contextOrbitalElement
            )
          },
          color: 'blueviolet',
          side: 'left',
          position: 0.14,
          anchor: 'free',
          overlaying: 'y'
        },
        yaxis5: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['perigeeArgument'],
              this.contextOrbitalElement
            )
          },
          color: 'chocolate',
          side: 'left',
          position: 0.07,
          anchor: 'free',
          overlaying: 'y'
        },
        yaxis6: {
          title: {
            text: this.getLabelWithUnitFromPath(
              ['anomaly'],
              this.contextOrbitalElement
            )
          },
          color: 'dodgerblue',
          side: 'left',
          position: 0,
          anchor: 'free',
          overlaying: 'y'
        },
        legend: {
          y: -0.3,
          orientation: 'h'
        }
      }
    },
    getTraceOrbitalsElements() {
      const tracesOrbitalsElements = []
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter('semiMajorAxis', true, 'blue', 'y')
      )
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter('inclination', true, 'green', 'y2')
      )
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter('eccentricity', true, 'red', 'y3')
      )
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter('raan', 'legendonly', 'blueviolet', 'y4')
      )
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter(
          'perigeeArgument',
          'legendonly',
          'chocolate',
          'y5'
        )
      )
      tracesOrbitalsElements.push(
        this.getTraceOrbitalParameter(
          'anomaly',
          'legendonly',
          'dodgerblue',
          'y6'
        )
      )

      return tracesOrbitalsElements
    }
  },
  methods: {
    async updateDataOrbitalsElements(isAllLife) {
      if (isAllLife == true) {
        this.orbitalData = await this.getOrbitalElementsFromMission(
          this.idSatellite,
          this.idMission
        )
        this.reactiveManeuverDate = this.maneuverDates
      } else {
        this.orbitalData = await this.getOrbitalElementsFromTles(this.tles)
        this.reactiveManeuverDate = []
      }
    },

    getTraceOrbitalParameter(pathParameter, isDisplay, color, yaxis) {
      let x
      let y
      if (this.orbitalData != null) {
        x = this.orbitalData.map((orbitalElements) =>
          this.getDisplayValueFromPath(
            orbitalElements.orbitDateTime,
            ['orbitDateTime'],
            this.contextOrbitalElement
          )
        )
        y = this.orbitalData.map((orbitalElements) =>
          this.getDisplayValueFromPath(
            orbitalElements[pathParameter],
            [pathParameter],
            this.contextOrbitalElement
          )
        )
      } else {
        x = undefined
        y = undefined
      }
      return {
        x: x,
        y: y,
        yaxis: yaxis,
        type: 'scatter',
        visible: isDisplay,

        name: pathParameter,
        marker: {
          color: color
        },
        mode: this.markerOrLine()
      }
    },
    markerOrLine() {
      if (this.isAllLife) {
        return 'line'
      } else {
        return 'marker+line'
      }
    }
  }
}
</script>

<style>
.legend-last-position-date {
  color: #5757ff;
}
.legend-previous-date {
  color: #5757ff;
}
.title {
  margin-left: 15px;
  font-size: large;
  margin-top: 10px;
}
</style>
